export default __webpack_public_path__ + "static/media/icaew_xl1.4b3175c2.png";